<template>
  <div class="simple-code">
    <!-- 条件搜索部分 -->
    <el-form class="zwx-form" key="mainForm" ref="mainForm" :model="mainForm" label-position="right" @submit.native.prevent>
      <div style="max-width: 472px;">
        <el-form-item label-width="70px" label="码表名称：">
          <el-input class="zwx-input" v-model="mainForm.codeNameLike" placeholder="请输入" @keyup.enter.native="search(1)"
                    clearable/>
        </el-form-item>
        <el-form-item label-width="42px" label="状态：">
          <el-checkbox-group class="zwx-checkbox-group" v-model="mainForm.ifEnables">
            <el-checkbox class="zwx-checkbox" :label="true">启用</el-checkbox>
            <el-checkbox class="zwx-checkbox" :label="false">停用</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </div>
    </el-form>
    <el-divider class="base-divider"/>
    <div style="padding: 12px 20px;">
      <el-button class="zwx-button zwx-button-icontext-28" type="primary" icon="el-icon-search" @click="search(1)">查询
      </el-button>
      <el-button class="zwx-button zwx-button-icontext-28" icon="el-icon-plus" @click="add()"
                 v-if="$validate.checkbtns(btns[0])">添加
      </el-button>
    </div>
    <!-- 列表展示部分 -->
    <el-table class="zwx-table" style="width: 100%;" row-key="rid" :data="dataList" border stripe>
      <el-table-column prop="codeLevelNo" label="码表结构层次编码"
                       :width="$system.calWidth(dataList, 'codeLevelNo', '码表结构层次编码')" header-align="left" align="left"
                       v-if="codeTypeIfTree"/>
      <el-table-column prop="codeNo" label="码表编码" :width="$system.calWidth(dataList, 'codeNo', '码表编码')"
                       header-align="center" align="center"/>
      <el-table-column prop="num" label="排序" :width="$system.calWidth(dataList, 'num', '排序')" header-align="center"
                       align="center"/>
      <el-table-column label="码表名称"
                       :width="$system.calWidth(dataList, 'codeName', '码表名称', '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0')"
                       header-align="left" align="left">
        <template slot-scope="scope">
          <template v-for="item in scope.row.codeLevelNo.split('.').length - 1" :row-key="item">{{ '\xa0\xa0\xa0' }}
          </template>
          <template>{{ scope.row.codeName }}</template>
        </template>
      </el-table-column>
      <el-table-column prop="standardCode" label="标准编码" :width="$system.calWidth(dataList, 'standardCode', '标准编码')"
                       header-align="center" align="center"/>
      <el-table-column fixed="right" label="操作"
                       :min-width="$system.calMinWidth({ wordNum: codeTypeIfTree ? 10 : 6, arrowNum: codeTypeIfTree ? 2 : 1, btnNum: codeTypeIfTree ? 5 : 4 })"
                       header-align="left" align="left">
        <template slot-scope="scope">
          <el-button class="zwx-button zwx-button-text-26" type="text" icon="el-icon-arrow-right"
                     @click="edit(scope.row)" v-if="$validate.checkbtns(btns[0])">编辑
          </el-button>
          <el-button class="zwx-button zwx-button-text-26" type="text" icon="el-icon-arrow-right"
                     @click="childAdd(scope.row)" v-if="codeTypeIfTree && $validate.checkbtns(btns[0])">子级添加
          </el-button>
          <el-button class="zwx-button zwx-button-text-26"
                     :style="scope.row.ifEnable ? 'color: #e72b00 !important;' : ''" type="text"
                     @click="$system.msgbox(scope.row, '提示', scope.row.ifEnable ? '确定要停用吗？' : '确定要启用吗？', '确定', '取消', enable)"
                     v-if="$validate.checkbtns(btns[0])">{{ scope.row.ifEnable ? '停用' : '启用' }}
          </el-button>
          <el-button class="zwx-button zwx-button-text-26" type="danger"
                     @click="$system.msgbox(scope.row, '提示', '确定要删除吗？', '确定', '取消', deletion)"
                     v-if="!scope.row.ifEnable && $validate.checkbtns(btns[0])">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器部分 -->
    <base-pagination :parentPage="currentPage" :pageSize="pageSize" :total="total" @currentChange="currentChange"/>
  </div>
</template>

<script>
export default {
  name: 'SimpleCode',
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      codeTypeId: this.$route.params.codeTypeId,
      codeTypeCode: this.$route.params.codeTypeCode,
      codeTypeName: this.$route.params.codeTypeName,
      codeTypeIfTree: this.$route.params.codeTypeIfTree,
      btns: ['d06b90b5f803e72d'],
      mainForm: {
        codeNameLike: '',
        ifEnables: [true],
      },
      dataList: [],
      currentPage: 1,
      pageSize: 18,
      total: 0,
    }
  },
  created() {
    this.$emit('breadcrumb', this.codeTypeName, false)
  },
  mounted() {
    this.search(this.currentPage)
  },
  activated() {
    if (this.$route.params.fresh) this.search(this.currentPage)
  },
  computed: {},
  methods: {
    currentChange(currentPage) {
      this.search(currentPage)
    },
    search(currentPage) {
      this.$emit('loading', true)
      this.currentPage = currentPage
      let data = {
        currentPage: this.currentPage,
        codeTypeCode: this.codeTypeCode,
        codeNameLike: this.mainForm.codeNameLike,
        ifEnable: this.mainForm.ifEnables.length === 1 ? this.mainForm.ifEnables[0] : null,
      }
      this.$system.get(this.api + '/systematic/getSimpleCodeList-1', data, true, true, this.searchSuccess, this.error)
    },
    searchSuccess(data) {
      if (data.type === '00') {
        this.dataList = data.simpleCodeList
        this.total = data.simpleCodeCount
        this.pageSize = data.pageSize
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
      }
      this.$emit('loading', false)
    },
    enable(row) {
      this.$emit('loading', true)
      let data = {rid: row.rid, ifEnable: !row.ifEnable}
      this.$system.post(this.api + '/systematic/modifySimpleCodeState-1', data, true, true, this.enableSuccess, this.error)
    },
    enableSuccess(data) {
      if (data.type === '00') {
        this.search(this.currentPage)
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    deletion(row) {
      this.$emit('loading', true)
      let data = {rid: row.rid}
      this.$system.post(this.api + '/systematic/deleteSimpleCode-1', data, true, true, this.deletionSuccess, this.error)
    },
    deletionSuccess(data) {
      if (data.type === '00') {
        this.$system.notify('成功', data.mess, 'success')
        this.search(this.currentPage)
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    add() {
      this.$router.push({name: 'SimpleCodeEdit', params: {codeTypeId: this.codeTypeId}})
    },
    edit(row) {
      this.$router.push({name: 'SimpleCodeEdit', params: {rid: row.rid}})
    },
    childAdd(row) {
      this.$router.push({name: 'SimpleCodeEdit', params: {parentId: row.rid, codeName: row.codeName}})
    },
    error() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
